module.exports = { id: "chevron-down", url: "/build/app/img/symbols.svg#chevron-down", viewBox: "", toString: function() { return this.url; } };